import type { RgbaColor } from "../types/models";

export function getRGBAFromColorObject(color: RgbaColor) {
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
}

export function getRGBFromColorObject(color: RgbaColor) {
  return `rgb(${color.r}, ${color.g}, ${color.b})`;
}

export const WHITE: RgbaColor = { r: 255, g: 255, b: 255, a: 1 };
